export const types = {
  CLEAR_ERROR: "CLEAR_ERROR",
  IS_LOADING: "IS_LOADING",
  LOG_ERROR: "LOG_ERROR",
};
